import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { PayorService } from 'src/app/service/payor/payor.service';

@Component({
  selector: 'app-payor-list',
  templateUrl: './payor-list.component.html',
  styleUrls: ['./payor-list.component.css']
})
export class PayorListComponent implements OnInit {
  search: any

  payorList: any = [];
  status = "active";

  constructor(
    private payorService: PayorService
  ) { }

  ngOnInit() {
    this.getPayorList();
  }

  getPayorList() {

    const queryParams = {
      status: this.status
    };

    this.payorService
      .getPayorList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  onChangeStatus(event: any) {
    this.status = event.target.value;
    this.getPayorList();
  }

  ngOnDestroy(): void {
  }

}
